import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { F0AvatarAlert, F0Button } from '@factorialco/f0-react'
import { AvailableModules } from 'generated/featureDefinitions'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import LeftSection from 'modules/upsell/components/SelfUpsell/CheckoutModal/LeftSection'
import type Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import { useSelfUpsellContext } from 'modules/upsell/store/SelfUpsellProvider'

const UpsellCreatedBox = () => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
      borderRadius={{ all: 'abs016' }}
      background="grey100"
      padding="s8"
      paddingBottom="s4"
      gap="s4"
      style={{
        flex: '1',
      }}
    >
      <Box
        alignItems="center"
        borderRadius={{ all: 'abs012' }}
        background="grey000White"
        boxShadow="s50"
        padding="s20"
        gap="s16"
      >
        <F0AvatarAlert type="positive" size="lg" />
        <Box textAlign="center" gap="s2">
          <Text.Normal size="200" weight="semibold" color="grey1000">
            {i18n.t('self_upsell.upgrade_plan_modal.upsell_created_step.title')}
          </Text.Normal>
          <Text.Normal size="200" color="grey700">
            {i18n.t('self_upsell.upgrade_plan_modal.upsell_created_step.description')}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

type UpsellCreatedStepProps = {
  addon: Plan
  step: string
  onClose: () => void
  moduleName: AvailableModules
}

const UpsellCreatedStep = ({ addon, step, onClose, moduleName }: UpsellCreatedStepProps) => {
  const { configPlan } = useSelfUpsellContext()
  const { isMobile } = useBreakpoint()

  const handleClose = () => {
    onClose()
    window.location.reload()
  }

  useEffect(() => {
    track(trackingEvents.upsell.viewSelfUpgradeUpsellCreatedStep, {
      module: moduleName,
    })
  }, [moduleName])

  return (
    <Box flexDirection="row" height="full">
      {!isMobile && (
        <LeftSection addon={addon} variant={configPlan.variant} step={step} iconName={moduleName} />
      )}
      <Box
        padding="s24"
        justifyContent="spaceBetween"
        style={{
          width: isMobile ? '100%' : '60%',
        }}
      >
        <Box
          gap="s16"
          style={{
            height: '100%',
          }}
        >
          <Box height="s24" />
          <Text.Normal weight="semibold" color="grey1000">
            {i18n.t('self_upsell.success_step.all_set')}
          </Text.Normal>
          <UpsellCreatedBox />
        </Box>
        <Box flexDirection="row" gap="s8" flexWrap="wrap" justifyContent="flexEnd" paddingTop="s24">
          <F0Button
            size="lg"
            variant="outline"
            label={i18n.t('self_upsell.success_step.close')}
            onClick={handleClose}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default UpsellCreatedStep
